module.exports = require("@adc/configment");